import React from "react";
import { Link } from "react-router-dom";
import { AiFillPhone , AiFillMail, AiFillHome  } from "react-icons/ai";
import { BiSolidChevronRight } from "react-icons/bi";

const Footer = () => {
  return (
    <>
      {/* Enquiry Section */}
      <div className="py-8 bg-gradient-to-r from-slate-700 via-slate-600 to-slate-900 text-white shadow-xl">
        <div className="container mx-auto text-center">
          <div className="flex flex-col lg:flex-row justify-center items-center gap-6">
            <div className="w-full lg:w-8/12">
              <p className="mb-0 text-center text-xl lg:text-2xl xl:text-3xl font-bold tracking-wide">
                Looking for Calibration & Testing Solutions?
              </p>
            </div>
            <div className="w-full lg:w-4/12">
              <Link to="/contact">
                <button className="px-8 py-3 bg-white text-slate-700 font-bold rounded-full hover:bg-slate-100 transition-all transform hover:scale-105 shadow-lg">
                  Make an Enquiry
                </button>
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Footer Section */}
      <footer className="bg-gradient-to-br from-slate-950 to-slate-900 text-white">
        <div className="container mx-auto px-6 py-12">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
            {/* Logo and Description */}
            <div className="space-y-6">
              <a href="/">
                <div className="flex items-center space-x-3">
                  <img
                    src="./img/logo.png"
                    alt="Logo"
                    className="h-24"
                  />
                </div>
              </a>
              <p className="text-slate-200 text-base leading-relaxed">
                ADARSH CALIBRATION LLP
                <br />
                <br />
                Office & Lab:
                <br />
                Flat No. 02, Madhu Sudhan Apartment,
                <br />
                Ambad Link Road, Near Ganesh Sweets,
                <br />
                MIDC Ambad, Nashik - 422010, Maharashtra
              </p>
            </div>

            {/* Links Section */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div>
                <h3 className="text-white font-bold text-xl mb-4 border-b-2 border-slate-500 pb-2 inline-block">Quick Links</h3>
                <ul className="space-y-3">
                  {[
                    { label: "Home", path: "/" },
                    { label: "About Us", path: "/about" },
                    { label: "Services", path: "/services" },
                    { label: "Gallery", path: "/gallery" },
                    { label: "Contact Us", path: "/contact" },
                  ].map((link) => (
                    <li key={link.label} className="group">
                      <Link
                        to={link.path}
                        className="flex items-center text-slate-300 hover:text-slate-300 transition-all group-hover:translate-x-1"
                      >
                        <BiSolidChevronRight className="mr-2 text-slate-200" />
                        {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
              <div>
                <h3 className="text-white font-bold text-xl mb-4 border-b-2 border-slate-500 pb-2 inline-block">Services</h3>
                <ul className="space-y-3">
                  {["Mechanical Instruments", "Electro-Technical Instruments", "Force & Hardness"].map(
                    (service) => (
                      <li key={service} className="group">
                        <Link
                          to="/services"
                          className="flex items-center text-slate-300 hover:text-slate-300 transition-all group-hover:translate-x-1"
                        >
                          <BiSolidChevronRight className="mr-2 text-slate-200" />
                          {service}
                        </Link>
                      </li>
                    )
                  )}
                </ul>
              </div>
            </div>

            {/* Contact Us Section */}
            <div>
              <h3 className="text-white font-bold text-xl mb-4 border-b-2 border-slate-500 pb-2 inline-block">Contact Us</h3>
              <ul className="space-y-4 text-slate-200">
                <li className="flex items-start gap-3">
                  <AiFillHome className="mt-1 text-slate-200 text-3xl" />
                  <span>
                    Office & Lab: Flat No. 02, Madhu Sudhan Apartment,
                    Ambad Link Road, Near Ganesh Sweets,
                    MIDC Ambad, Nashik - 422010, Maharashtra
                  </span>
                </li>
                <li className="flex items-center gap-3">
                  <AiFillPhone className="text-slate-200 text-xl" />
                  <span>
                    +91 97305 91596
                    <br />
                    +91 76207 75921
                  </span>
                </li>
                <li className="flex items-center gap-3">
                  <AiFillMail className="text-slate-200 text-xl" />
                  <span>cal.adarsh24@gmail.com</span>
                </li>
              </ul>
            </div>
          </div>

          {/* Footer Bottom */}
          <div className="mt-12 border-t border-slate-700 pt-6">
            <p className="text-center text-base text-slate-300">
              Copyright © 2024 Adarsh Calibration LLP. All rights reserved.
            </p>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
